'use client';

import { ErrorBoundary, Provider } from '@rollbar/react';
import React, { PropsWithChildren } from 'react';

import { getRollbarConfig } from '@/utils/rollbar';
import ErrorView from '@/views/error/error';

import type Rollbar from 'rollbar';

const RollbarProvider: React.FC<PropsWithChildren<{ instance?: Rollbar }>> = ({
  children,
  instance,
}) => {
  return (
    <Provider
      {...(instance ? { instance } : { config: getRollbarConfig(true) })}
      instance={instance}
    >
      <ErrorBoundary
        errorMessage="Error in React render"
        fallbackUI={ErrorView} // Rollbar is wrongly typed (https://github.com/rollbar/rollbar-react/issues/87)
        extra={(_error, _info) => ({
          // Extra information that need to be sent to rollbar
        })}
      >
        {children}
      </ErrorBoundary>
    </Provider>
  );
};

export default RollbarProvider;
